import { GridColDef } from '@mui/x-data-grid-pro';
import { RenderFolder, RenderName } from './cellDefinitions';

const nameColumn: GridColDef = {
  field: 'name',
  headerName: 'Name',
  width: 300,
  minWidth: 270,
  filterable: false,
  sortable: false,
  flex: 1,
  renderCell: RenderName,
};

const folderColumn: GridColDef = {
  field: 'folder',
  headerName: 'Folder',
  width: 200,
  minWidth: 120,
  filterable: false,
  sortable: false,
  renderCell: RenderFolder,
};

export const browseColumns: GridColDef[] = [nameColumn];

export const searchColumns: GridColDef[] = [nameColumn, folderColumn];
